import axios from 'axios'
import router from '@/router'
import Swal from 'sweetalert2'

const authModule = {
  namespaced: true,

  state: () => ({
    authorizationFinished: false
  }),

  getters: {
    getAuthorizationFinished (state) {
      return state.authorizationFinished
    }
  },

  mutations: {
    setAuthorizationFinished (state, isFinished) {
      state.authorizationFinished = isFinished
    }
  },

  actions: {
    logout () {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('username')
      localStorage.removeItem('email')
      localStorage.removeItem('permissions')
      router.push('/login').then(() => Swal.fire('Twoja sesja wygasła', 'Wylogowano Cię z programu, ponieważ upłynął czas aktywnej sesji. Zaloguj się ponownie.', 'warning'))
    }
  }
}

export default authModule
